import React from 'react';
import Button from '@mui/material/Button';

const MuiButton = ({ onClick, children, large = false, ...props }) => {

	let size ="medium";
	if(large)
		size = "large";
    
  return (
    <Button 
      variant="contained" 
      size={size}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export default MuiButton;